import ReportHeaderBarItems from 'app/common/templates-next/report-template/report-header-bar-items'
import { ReportType } from 'app/dataTypes/reports'

import { History } from 'app/components/common/reports/v3/history'
import { ReportFile } from 'app/components/common/reports/ReportFile/report-file'

type Props = {
  reportId: string | null
  reportReady: boolean
}

export const HeaderBar = ({ reportId, reportReady }: Props) => {
  return (
    <ReportHeaderBarItems>
      {reportId && reportReady && (
        <ReportFile reportID={reportId} filenameBase={ReportType.AverageCheck} />
      )}

      <History reportType={ReportType.AverageCheck} filenameBase={ReportType.AverageCheck} />
    </ReportHeaderBarItems>
  )
}
